import React from 'react'
import CentresContainers from '../containers/Centres'

const Centres = () => {
  return (
    <div>
      <CentresContainers/>
    </div>
  )
}

export default Centres
